import { IEventDefinition } from "@highway/mbs-analytics";

/**
 * The sample-report landing page (MIG-8637) — the page the widget's email links to.
 *
 * Names are STATIC rather than `${context?.eventPrefix}_...` like most events in this registry.
 * The prefix comes from the active tool, and this page is not a tool: the prefix resolves to
 * `undefined`, and `AnalyticsManager` drops any event whose mapped name contains that string.
 *
 * Only the browser half of the funnel is here. The widget's own submit event is raised by
 * mbs-api (`sample_report_widget_submit`) because it fires from the partner's domain — see the
 * comment on that constant in `sample-reports.service.ts`. The three share a `sample_id`
 * property and a `sample:<sampleId>` distinct id, which is what joins them into one funnel.
 */
export const appEvents: Record<string, IEventDefinition> = {
    sample_report_page_view: {
        description: "Fires when a sample-report requester opens the landing page linked in their email.",
        mappings: {
            mixpanel: "sample_report_page_view",
        },
    },
    sample_report_download_click: {
        description:
            "Fires when a sample-report requester clicks 'Download now' on the landing page. " +
            "Carries no identity — join on sample_id for the details they entered.",
        mappings: {
            mixpanel: "sample_report_download_click",
        },
    },
};
